import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { fetchAuthSession } from 'aws-amplify/auth';
import FileSaver from 'file-saver';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.css'],
})
export class UploadFilesComponent implements OnInit {
  s3ServiceRoute: any = `${environment.salesApi}/api/v1`;

  @Input() numberOS: any;

  multimedia: any = [];

  pdfViewer: any = false;
  index: any;
  url: any;

  private async getAuthHeaders(): Promise<HttpHeaders> {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();

      if (token) {
        return new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        });
      } else {
        console.warn('⚠️ No hay token disponible para autenticación');
        return new HttpHeaders({
          'Content-Type': 'application/json',
        });
      }
    } catch (error) {
      console.error('❌ Error obteniendo token para headers:', error);
      return new HttpHeaders({
        'Content-Type': 'application/json',
      });
    }
  }

  constructor(
    private sanitizer: DomSanitizer,
    public loadingService: LoadingService,
    private http: HttpClient,
    public dialogRef: MatDialogRef<UploadFilesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.getAllMultimedia();
  }

  getBase64 = (file: any, cb: any) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  async onFileSelected(event: any) {
    console.log(event.target.files);

    if (event.target.files) {
      let base64 = '';

      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];

        const allowedTypes = [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'image/jpeg',
          'image/png',
        ];

        if (allowedTypes.includes(file.type)) {
          this.getBase64(file, async (result: any) => {
            base64 = result;

            try {
              const headers = await this.getAuthHeaders();

              console.log(this.data.reservaId);
              const upload = this.http.post(
                `${this.s3ServiceRoute}/addFileAnulacionOS`,
                {
                  data: base64,
                  numberOS: this.numberOS,
                  fileName: file.name,
                },
                { headers }
              );

              upload.subscribe((response: any) => {
                const image = {
                  src: result,
                  key: response.key,
                  name: file.name,
                  nameDownload: file.name,
                };

                this.multimedia.push(image);
              });
            } catch (error) {
              console.error('Error al subir archivo:', error);
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: 'Error al subir',
                text: 'Error de autenticación al subir el archivo',
                showConfirmButton: false,
                timer: 4000,
              });
            }
          });
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Error al subir',
            text: `Este formato no está soportado: ${file.name}`,
            showConfirmButton: false,
            timer: 4000,
          });
        }
      }
    }
  }

  async getAllMultimedia() {
    try {
      const headers = await this.getAuthHeaders();
      const multimedia = this.http.get(
        `${this.s3ServiceRoute}/getFilesNumberOS/${this.numberOS}`,
        { headers }
      );

      multimedia.subscribe(async (response: any) => {
        console.log(response);
        for (const el of response) {
          try {
            const multimediaDetail = this.http.get(
              `${this.s3ServiceRoute}/getFileAnulacionOS/${el.Key}`,
              { headers }
            );

            multimediaDetail.subscribe((res: any) => {
              let binary = '';
              let bytes = new Uint8Array(res.data);
              let len = bytes.byteLength;
              for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
              }

              const split = el.Key.split(';').pop();
              const nameDownload = split.split('.')[0];
              const fileType = binary.split(';')[0];

              const image = {
                src: binary,
                key: el.Key,
                name: split,
                nameDownload: nameDownload,
              };

              console.log(image);
              this.multimedia.push(image);
            });
          } catch (error) {
            console.error('Error al obtener detalle de multimedia:', error);
          }
        }
      });
    } catch (error) {
      console.error('Error al obtener multimedia:', error);
    }
  }

  downloadFile(multimedia: any) {
    const split = multimedia.src.split(',');
    const type = split[0];
    const binary = split[1];

    const byteCharacters = atob(binary);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    console.log(byteCharacters);
    const blob = new Blob([byteArray], { type: type });
    FileSaver.saveAs(blob, multimedia.name);
  }

  async deleteMultimedia(el: any, i: any) {
    console.log(el, i);

    try {
      const headers = await this.getAuthHeaders();
      const deleted = this.http.delete(
        `${this.s3ServiceRoute}/deleteFileAnulacionOS/${el.key}`,
        { headers }
      );

      deleted.subscribe((response: any) => {
        console.log(response);
      });

      this.multimedia.splice(i, 1);
    } catch (error) {
      console.error('Error al eliminar multimedia:', error);
    }
  }

  activatePDF(multimedia: any, index: any) {
    if (index == this.index) {
      this.pdfViewer = false;
      this.index = null;
    } else {
      this.index = index;
      //this.url=multimedia.src
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(multimedia.src);
      this.pdfViewer = true;
    }
  }
}
